import {
  FETCH_REFER_EARN_OPTIONS,
  FETCH_REFERRAL_LOGS,
  USER_LOGOUT,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_VALUE,
  SEND_MULTIPLE_REFERRAL_REQUESTS,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

const initialState: App.ReferState = {
  earnOptions: [],
  referralLogs: undefined,
  referralCode: undefined,
  referralValue: undefined,
  fetching: false,
  referralRequestsSent: undefined,
  utm: undefined,
}

const apiCalls = apiReducerSwitch<App.ReferState>({
  [FETCH_REFER_EARN_OPTIONS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      earnOptions: action.data.result.earn_options,
      fetching: false,
    }),
    failure: () => ({
      earnOptions: [],
      fetching: false,
    }),
  },
  [FETCH_REFERRAL_LOGS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      referralLogs: action.data.result,
      fetching: false,
    }),
    failure: () => ({
      fetching: false,
      referralLogs: undefined,
    }),
  },
  [FETCH_REFERRAL_CODE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      referralCode: action.data.result.details.referral_code,
      utm: action.data.result.meta_data,
      fetching: false,
    }),
  },
  [FETCH_REFERRAL_VALUE]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      referralValue: action.data.result,
      fetching: false,
    }),
    failure: () => ({
      fetching: false,
      referralValue: undefined,
    }),
  },
  [SEND_MULTIPLE_REFERRAL_REQUESTS]: {
    request: () => ({
      fetching: true,
    }),
    success: (state, action) => ({
      fetching: false,
      referralRequestsSent: action.data,
    }),
    failure: () => ({
      fetching: false,
      referralRequestsSent: undefined,
    }),
  },
  [USER_LOGOUT]: {
    success: () => ({
      referralLogs: undefined,
      referralCode: undefined,
      utm: undefined,
      referralRequestsSent: undefined,
    }),
  },
})

export default createAppReducer<App.ReferState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
